import { useCallback } from 'react';
import { toast } from 'react-hot-toast';

export function useImageUpload() {
  const handleImageUpload = useCallback(async (file: File) => {
    try {
      console.log('Uploading file:', file.type);
      const reader = new FileReader();
      
      reader.onload = (e) => {
        const imageUrl = e.target?.result as string;
        console.log('File read as data URL:', imageUrl.substring(0, 50) + '...');
        
        // Dispatch event with image data
        const event = new CustomEvent('addImage', {
          detail: { imageUrl, fileType: file.type }
        });
        window.dispatchEvent(event);
        
        // Close the design options toolbar
        window.dispatchEvent(new CustomEvent('closeDesignOptionsToolbar'));
        
        toast.success('Image uploaded successfully');
      };

      reader.onerror = (error) => {
        console.error('FileReader error:', error);
        toast.error('Failed to read image file');
      };

      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Error uploading image:', error);
      toast.error('Failed to upload image');
    }
  }, []);

  return { handleImageUpload };
}